var parse=require('../parse/index.js');var getISOWeek=require('../get_iso_week/index.js');/**
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} isoWeek - the ISO week of the new date
 * @returns {Date} the new date with the ISO week setted
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * var result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */function setISOWeek(dirtyDate,dirtyISOWeek){var date=parse(dirtyDate);var isoWeek=Number(dirtyISOWeek);var diff=getISOWeek(date)-isoWeek;date.setDate(date.getDate()-diff*7);return date;}module.exports=setISOWeek;